/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 Tickets = {
    previousContentHtml: '',
    filterOnlyPendent: function() {
        var filtered = $(this).is(':checked');

        $.ajax({
            url: '/a/user/tickets/filterOnlyPendent',
            type: 'POST',
            dataType: 'json',
            data: {'filtered': filtered},
        }).done(function(data) {
            $(".tickets-list").html(data.html);
        });
    },
    create: {
        html: '',
        show: function() {
            var content = $(".tickets-content-area");
            Tickets.previousContentHtml = content.html();

            if (Tickets.create.html == '') {
                Tickets.create.html = $(".tickets-content-area-html").html();
                $(".tickets-content-area-html").remove();
            }

            content.html(Tickets.create.html);
        },
        send: function(e) {
            e.preventDefault();

            var form = $(this);

            if (form.hasClass('disabled')) {
                return false;
            }

            var title      = form.find('input[name="title"]').val();
            var department = form.find('select[name="department"]').val();
            var category   = form.find('select[name="category"]').val();
            var content    = form.find('textarea[name="content"]').val();

            if (department == 0 || category == 0 || content == '') {
                form.effect('shake', { distance: 3 });
            } else {
                form.addClass('disabled').animate({'opacity': 0.5});

                $.ajax({
                    url: '/a/user/tickets/create',
                    type: 'POST',
                    dataType: 'json',
                    data: {'title': title, 'department': department, 'category': category, 'content': content},
                }).done(function(data) {
                    form.removeClass('disabled').animate({'opacity': 1});

                    if (data.status == 'error') {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao enviar ticket",
                            content: message,
                            type: 'error'
                        });
                    } else {
                        $.fancybox.close();

                        Alertbox({
                            title: 'Enviado com sucesso!',
                            content: "Seu ticket foi enviado com sucesso. Em breve você receberá uma resposta da nossa equipe.",
                            type: 'success'
                        });

                        setTimeout(function() {
                            location.reload();
                        }, 2000);
                    }
                });
            }
        }
    },
    back: function() {
        $(".tickets-content-area").html(Tickets.previousContentHtml);
    },
    isOpen: false,
    openedId: 0,
    open: function() {
        var id = $(this).closest('.ticket-box').data('id');

        var content = $(".tickets-content-area");

        if (Tickets.isOpen === false) {
            Tickets.previousContentHtml = content.html();
        }

        Tickets.isOpen = true;
        Tickets.openedId = id;

        $.ajax({
            url: '/a/user/tickets/open',
            type: 'POST',
            dataType: 'json',
            data: {'id': id},
        }).done(function(data) {
            if (data.status == 'error') {
                var message = "";

                for (i = data.messages.length - 1; i >= 0; i--) {
                    message += data.messages[i];

                    if (i > 0) {
                        message += '<br>';
                    }
                }

                Alertbox({
                    title: "Erro ao enviar mensagem",
                    content: message,
                    type: 'error'
                });
            } else {
                content.html(data.html);
            }
        });
    },
    answer: function(e) {
        e.preventDefault();

        var form = $(this);

        if (form.hasClass('disabled')) {
            return false;
        }

        var content = form.find('textarea[name="content"]').val();

        if (content == '') {
            form.effect('shake', { distance: 3 });
        } else {
            form.addClass('disabled').animate({'opacity': 0.5});

            $.ajax({
                url: '/a/user/tickets/answer',
                type: 'POST',
                dataType: 'json',
                data: {'id': Tickets.openedId, 'content': content},
            }).done(function(data) {
                form.removeClass('disabled').animate({'opacity': 1});

                if (data.status == 'error') {
                    var message = "";

                    for (i = data.messages.length - 1; i >= 0; i--) {
                        message += data.messages[i];

                        if (i > 0) {
                            message += '<br>';
                        }
                    }

                    Alertbox({
                        title: "Erro ao responder ticket",
                        content: message,
                        type: 'error'
                    });
                } else {
                    $(".tickets-answer-list").append(data.html);
                }
            });
        }
    },
    init: function() {
        $(".tickets-list").slimScroll({
            height: '359px'
        });

        $("#tickets-filter-only-pendent").on('change', Tickets.filterOnlyPendent);

        $(document).on('click', ".tickets-create-button", Tickets.create.show);
        $(document).on('click', ".tickets-back-icon", Tickets.back);

        $(document).on('submit', ".ticket-create-form", Tickets.create.send);
        $(document).on('submit', ".ticket-answer-form", Tickets.answer);

        $(document).on('click', ".ticket-box .title", Tickets.open);
    }
};
